import { XStack, YStack } from "tamagui";
import { Bar } from "./Bar";
import { BillGraphicHeader } from "./BillGraphicHeader";
import { FannedCards } from "./FannedCards";
const ROW_HEIGHT = 16;
const FIXED_BAR_WIDTH = 64;

// One content row — a 16px-tall row (matching Figma) holding a pill bar. `full`
// bars stretch to the card width minus a right inset; otherwise fixed-width.
const BillBar = ({
  full
}: {
  full?: boolean;
}) => <XStack width="100%" height={ROW_HEIGHT} alignItems="center" paddingRight={full ? "$sp1" : undefined} data-sentry-element="XStack" data-sentry-component="BillBar" data-sentry-source-file="BillGraphic.tsx">
    {full ? <Bar flex /> : <Bar width={FIXED_BAR_WIDTH} />}
  </XStack>;

// Bill card: a member avatar overlapping the Granted mark, then content bars
// anchored to the bottom — evoking a linked account whose bills are monitored.
export const BillGraphic = () => <FannedCards data-sentry-element="FannedCards" data-sentry-component="BillGraphic" data-sentry-source-file="BillGraphic.tsx">
    <BillGraphicHeader data-sentry-element="BillGraphicHeader" data-sentry-source-file="BillGraphic.tsx" />
    <YStack width="100%" flex={1} gap="$sp0.25" justifyContent="flex-end" paddingBottom="$sp0.75" data-sentry-element="YStack" data-sentry-source-file="BillGraphic.tsx">
      <BillBar full data-sentry-element="BillBar" data-sentry-source-file="BillGraphic.tsx" />
      <BillBar data-sentry-element="BillBar" data-sentry-source-file="BillGraphic.tsx" />
      <BillBar full data-sentry-element="BillBar" data-sentry-source-file="BillGraphic.tsx" />
    </YStack>
  </FannedCards>;